module.exports = __webpack_public_path__ + "media/images/shop-dashboard-home-f762506ccfaeda2847ec1d0f72f1ddd0.png";